import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {roleActions} from "../../../actions/role.actions";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import RoleClaimsTable from "./_components/RoleClaimTable";
import {Typeahead} from "react-bootstrap-typeahead";
import {networkDeviceActions} from "../../../actions/network-device.actions";

class RoleEditPage extends Component {

    state = {
        form: {
            id: null,
            label: null,
            description: null,
            isSuperAdmin: null,
            networkDeviceFullAccess: true,
            roleClaim: null,
            allPermissionLevels: null,
            networkDeviceIds: [],
        },
        selectedList: null,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        const id = this.props.match.params.id;
        dispatch(networkDeviceActions.getDropDownList());
        dispatch(roleActions.getRoleById(id));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.roleElement !== this.props.roleElement) {
            const { roleElement } = this.props;
            this.setState({
                ...this.state,
                form: {
                    id: roleElement.id,
                    label: roleElement.label,
                    description: roleElement.description,
                    isSuperAdmin: roleElement.isSuperAdmin,
                    roleClaim: roleElement.roleClaim,
                    networkDeviceFullAccess: roleElement.networkDeviceFullAccess,
                    allPermissionLevels: roleElement.allPermissionLevels,
                    networkDeviceIds: roleElement.networkDeviceIds,
                }
            });
        }

        if(this.state.selectedList == null && this.props.dropdownList !== null && this.state.form.id) {
            this.setState({
                ...this.state,
                selectedList: this.props.dropdownList.filter((item) => this.state.form.networkDeviceIds.includes(item.id))
            });

            console.log({
                ...this.state,
                selectedList: this.props.dropdownList.filter((item) => this.state.form.networkDeviceIds.includes(item.id))
            })
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.checked
            }
        })
    }

    handleOnChangeClaims = (data) => {
        const permissionLevel = this.state.form.allPermissionLevels.find((params) => params.id === data.levelPermissionId);
        const roleClaims = this.state.form.roleClaim;
        // eslint-disable-next-line array-callback-return
        roleClaims.find((params) => {
            if(params.id === data.id) {
                params.claimPermissionLevel = permissionLevel;
                params.claimPermissionLevelId = data.levelPermissionId
            }
        });

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                roleClaim: roleClaims
            }
        })
    };

    handleChangeNetworkDevices = (networkDeviceList) => {
        console.log(networkDeviceList);
        this.setState({
            ...this.state,
            selectedList: networkDeviceList,
            form: {
                ...this.state.form,
                networkDeviceIds: networkDeviceList.map((item) => item.id)
            }
        })
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        const id = this.props.match.params.id;
        dispatch(roleActions.editRole(this.state.form, id));
    };

    render() {
        const { t, roleElement, dropdownList } = this.props;

        console.log(this.state.selectedList);

        const breadcrumb = [
            { value: 'roles', path: '/panel/role' },
            { value: roleElement?.label ? roleElement.label : 'Loading ...', path: '#' }
        ];


        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('roles') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to={"/panel/role"}>
                                <button className="btn btn-secondary float-right">
                                    <i className="fas fa-undo"> </i> <span>{t('back-to-list')}</span>
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <form className="row" onSubmit={this.handleOnSubmit}>
                            <div className="col-md-5">
                                <div className="form-group">
                                    <label className="col-form-label">{t('label')}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="label"
                                        value={this.state.form.label || ''}
                                        onChange={this.handleOnChangeInput}
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="col-form-label">{t('description')}</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={this.state.form.description || ''}
                                        onChange={this.handleOnChangeInput}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">{t('isSuperAdmin')}</label>
                                    <input
                                        type="checkbox"
                                        className="form-check"
                                        name="isSuperAdmin"
                                        checked={this.state.form.isSuperAdmin || false}
                                        onChange={this.handleOnChangeCheckbox}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">{t('networkDeviceFullAccess')}</label>
                                    <input
                                        type="checkbox"
                                        className="form-check"
                                        name="networkDeviceFullAccess"
                                        checked={this.state.form.networkDeviceFullAccess}
                                        onChange={this.handleOnChangeCheckbox}
                                    />
                                </div>

                                { (this.state.form.networkDeviceFullAccess === false && dropdownList)  && (
                                    <div className="form-group">
                                        <label className="col-form-label">{t('network-devices')}</label>
                                        <Typeahead
                                            id="network-devices"
                                            labelKey={option => {
                                                return option.label || ""
                                            }}
                                            multiple
                                            required
                                            selected={this.state.selectedList || []}
                                            onChange={(selected) => this.handleChangeNetworkDevices(selected)}
                                            options={dropdownList}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="col-md-12">
                                <RoleClaimsTable
                                    roleClaims={this.state.form.roleClaim}
                                    permissionLevel={this.state.form.allPermissionLevels}
                                    onChangeClaimsPermissionLevel={this.handleOnChangeClaims}
                                />
                            </div>

                            <div className="col-md-12 pb-5">
                                <div className="form-group">
                                <button type="submit" className="btn btn-primary ">
                                        <i className="fas fa-edit"> </i> {t('edit')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    const { dropdownList } = state.networkDeviceReducer;
    const { roleElement } = state.roleReducer;
    return {
        roleElement, dropdownList
    }
};
export default withNamespaces()(connect(mapStateToProps)(RoleEditPage));
